// extracted by mini-css-extract-plugin
export default {"container":"PhotoText_container__rjPm-","container_flex":"PhotoText_container_flex__5F3v8","photo":"PhotoText_photo__ZgNzo","paragraph":"PhotoText_paragraph__DXSE+"};